import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import { MuiThemeProvider } from 'material-ui/styles'
import mui from 'themes/mui'
import css from './main.css'
import { firebaseAuth } from 'config/firebase'
import queryString from 'query-string'
import MainHelmet from 'components/base/mainHelmet'
import normalize from './normalize.css'
import Cookies from 'js-cookie'

class Blank extends React.Component {
  componentDidMount() {
    if (this.props.location.search) {
      const parsed = queryString.parse(this.props.location.search)
      if (parsed.token) {
        firebaseAuth().signInWithCustomToken(parsed.token)
        .catch(function(error) {
          // Handle Errors here.
          var errorCode = error.code;
          var errorMessage = error.message;
          console.log(`${errorCode}: ${errorMessage}`)
          // ...
        })
      }

      if (parsed.ref) {
          Cookies.set('referralSlug', parsed.ref, { expires: 365 })
      }
    }
  }

  render() {
    return (
      <MuiThemeProvider theme={mui} sheetsManager={new Map()}>
        <div css={{ display: 'flex', flex: 1, flexDirection: 'column', margin: 0, padding: 0}}>
          <MainHelmet />
            {typeof this.props.children === 'function' ? this.props.children() : this.props.children }
        </div>
      </MuiThemeProvider>
    )

  }
}
  

Blank.propTypes = {
  children: PropTypes.func,
}

export default Blank



// WEBPACK FOOTER //
// ./src/layouts/blank.js